import React, { useState, useRef, useEffect } from "react";

const ChevronIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    style={{
      position: "absolute",
      right: 10,
      top: "50%",
      transform: "translateY(-50%)",
    }}
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      style={{ stroke: "var(--od-c-717680, #717680)" }}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 6L9 17L4 12"
      stroke="#1982C4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Dropdown = ({ label, value, options, onChange, helpText }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selected = options.find((o) => String(o.value) === String(value));

  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <div
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: "var(--od-c-717680, #717680)",
            marginBottom: 4,
          }}
        >
          {label}
        </div>
      )}
      <div ref={ref} style={{ position: "relative" }}>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          style={{
            width: "100%",
            padding: "6px 10px",
            paddingRight: 32,
            fontSize: 14,
            fontWeight: 500,
            color: "var(--od-c-333333, #333)",
            lineHeight: "20px",
            backgroundColor: "var(--od-c-ffffff, #fff)",
            border: open ? "1px solid #1982C4" : "1px solid var(--od-c-d5d7da, #d5d7da)",
            borderRadius: 8,
            boxShadow: open
              ? "0px 0px 0px 4px rgba(25,130,196,0.15), 0px 1px 2px 0px rgba(10,13,18,0.05)"
              : "0px 1px 2px 0px rgba(10,13,18,0.05)",
            cursor: "pointer",
            textAlign: "left",
            position: "relative",
          }}
        >
          {selected ? selected.label : "Select..."}
          <ChevronIcon />
        </button>
        {open && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              width: "100%",
              backgroundColor: "var(--od-c-ffffff, #fff)",
              border: "1px solid var(--od-c-e9eaeb, #e9eaeb)",
              borderRadius: 8,
              boxShadow:
                "0px 12px 16px -4px rgba(10,13,18,0.08), 0px 4px 6px -2px rgba(10,13,18,0.03), 0px 2px 2px -1px rgba(10,13,18,0.04)",
              padding: "4px 0",
              zIndex: 100,
              maxHeight: 256,
              overflowY: "auto",
            }}
          >
            {options.map((opt) => {
              const isActive = String(opt.value) === String(value);
              return (
                <div
                  key={opt.value}
                  onClick={() => {
                    onChange(opt.value);
                    setOpen(false);
                  }}
                  style={{
                    padding: "1px 6px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 8,
                      borderRadius: 6,
                      backgroundColor: isActive ? "var(--od-c-fafafa, #fafafa)" : "transparent",
                    }}
                  >
                    <div>
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "var(--od-c-333333, #333)",
                          lineHeight: "20px",
                        }}
                      >
                        {opt.label}
                      </span>
                      {opt.sublabel && (
                        <div
                          style={{
                            fontSize: 12,
                            color: "var(--od-c-717680, #717680)",
                            lineHeight: "16px",
                          }}
                        >
                          {opt.sublabel}
                        </div>
                      )}
                    </div>
                    {isActive && <CheckIcon />}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {helpText && (
        <div
          style={{
            fontSize: 12,
            color: "var(--od-c-717680, #717680)",
            marginTop: 4,
          }}
        >
          {helpText}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
